export default __webpack_public_path__ + "static/media/mail.534d40e6.svg";